import styles from './NIBranding.module.scss';

const logo = '/ni-logo-maps.svg';

const NIBranding = props => {
    return (
        <div
            className={styles.container}
            data-testid='NIBranding'
        >
            <img className={styles.img} src={logo} alt="NI Branding"/>
        </div>
    );
};

export default NIBranding;
